export const homes = [{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652953"
  },
  "name": "1997 homestay",
  "address": "1997 Homestay, Rishikesh, Tehri Garhwal",
  "email": "snehakathait373@gmail.com",
  "phone": "Mobile: 9457891917"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652997"
  },
  "name": "ajay lal",
  "address": "Village & P.O. Pandukeshwar Tehsil, Joshimath, Chamoli",
  "email": "AjAyPandwal1993@gmail.com",
  "phone": "Mobile: 9411104478"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65299a"
  },
  "name": "ajay negi (byasi home stay)",
  "address": "Village Kaha nehra punah, Chakrata, Dehradun",
  "email": "negi.ajay096@gmail.com",
  "phone": "Mobile: 9412967977"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529a1"
  },
  "name": "ajeet singh",
  "address": "VILLAGE & POST - PAIDUL, PAIDULSYUN, PAURI",
  "email": "myvillagestay@gmail.com",
  "phone": "Mobile: 9759860919"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529a6"
  },
  "name": "ajeet singh chawla",
  "address": "VILLAGE KYARKULI, MUSSOORIE, DEHRADUN",
  "email": "angadchawla@outlook.com",
  "phone": "Mobile: 9988999132"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529ae"
  },
  "name": "akbar singh",
  "address": "29, Bhitri, Doni, Uttarkashi, Uttarkashi, Uttarkashi",
  "email": "94129314880@gmail.com",
  "phone": "Mobile: 9412931488-9412931488"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529c0"
  },
  "name": "amar saigol (sukoon home stay)",
  "address": "7 Kuthal Gate, Post Office Rajpur , Dehradun, Dehradun",
  "email": "saigol.amar@gmal.com",
  "phone": "Mobile: 9897489261-9897489261"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529cf"
  },
  "name": "ambabari home stay, kesav dutt bhatt",
  "address": "VILL GARHWALI POST KATHPUDIYA ALMORA, ALMORA, ALMORA",
  "email": "ARUN_BHATT@YAHOO.IN",
  "phone": "Mobile: 7310919789"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529e5"
  },
  "name": "amita verma",
  "address": "Gauri Kunj, Village Judda, Post Office Maral ( Via, Rishikesh, Pauri Garhwal",
  "email": "averma45@gmail.com",
  "phone": "Mobile: 9410972585"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529f0"
  },
  "name": "anand lal",
  "address": "VILLAGE AND POST OFFICE GAUNA, BLOCK DASHOLI TEHSIL CHAMOLI, CHAMOLI",
  "email": "anandlal@gmail.com",
  "phone": "Mobile: 7579257978"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529f8"
  },
  "name": "amrit bhawan radhey lal chamoli",
  "address": "Amrit Bhawan Sanyas Marg, Kankhal, Haridwar",
  "email": "hello@amritbhawan.in",
  "phone": "Mobile: 9897676899Ph: 01334-240659"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529fc"
  },
  "name": "anasuya devi home stay",
  "address": "Sarmoli Munsiyari, MUNSIYARI, PITHORAGARH",
  "email": "Anasuya@gmail.com",
  "phone": "Mobile: 8941024898"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a06"
  },
  "name": "anil kumar (shanti home stay)",
  "address": "Lane No.01 Malviya Nagar Patelnagar, Near Mahant Indresh Hospital Dehrakhas, Dehradun",
  "email": "anil.arti.382205@gmail.com",
  "phone": "Mobile: 9412055340-9412055340"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a09"
  },
  "name": "anil kumar sharma (shri ram shanti dham homestay)",
  "address": "Shewala Khurd, Post Office-Mohabbewala, Near Mansha Devi Temple , Dehradun",
  "email": "sunilsharma94129@gmail.com",
  "phone": "Mobile: 9412915506"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a10"
  },
  "name": "anil singh lodhiyal",
  "address": "House no 138, Mukteshwar, Nainital",
  "email": "lodhiyal007@gmail.com",
  "phone": "Mobile: 9888811637"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a1d"
  },
  "name": "anjali mathur",
  "address": "01, nathuakhan , nainital",
  "email": "anjalimathur123homestay@gmail.com",
  "phone": "Mobile: 9810405837"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a1e"
  },
  "name": "anil verma",
  "address": "10, lohaghat, champawt",
  "email": "ANIL123@VERMAGMAIL.COM",
  "phone": "Mobile: 8057576505"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a22"
  },
  "name": "anju gupta (karat-87 home stay)",
  "address": "Crown Brewery Estate, Barlowganj Road, Mussoorie, Dehradun",
  "email": "macadamroadmakers@yahoo.com",
  "phone": "Mobile: 9811107600"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a23"
  },
  "name": "anju kuwarbi",
  "address": "288/1, Ranikhet, Almora",
  "email": "digamber.semite@gmail.com",
  "phone": "Mobile: 7037440911"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65295f"
  },
  "name": "aanchal homestay",
  "address": "Barsu , Bhatwari , Uttarkashi",
  "email": "7500316344@gmail.com",
  "phone": "Mobile: 7500316341"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652963"
  },
  "name": "aanchal homestay  kewalanand belwal",
  "address": "W.4/39, Bhowali, Nainital",
  "email": "kbelwal91@gmail.com",
  "phone": "Mobile: 8057993563"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65296d"
  },
  "name": "abbal singh rawat",
  "address": "Village Parsari P.O. Badagaon Tehsil , Joshimath, Chamoli",
  "email": "abbalsinghrawat1963@gmail.com",
  "phone": "Mobile: 9760932047"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652973"
  },
  "name": "abhijay singh",
  "address": "hall no 13, letibunga, mukteshwar, nainital",
  "email": "thewhiterockshimalayan@gmail.com",
  "phone": "Mobile: 9560110386"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65297f"
  },
  "name": "adarsh home stay",
  "address": "Village Agathalla P.O. Pipalkoti Tehsil Chamoli, Tehsil Chamoli, Chamoli",
  "email": "birendrabisht1111@gmail.com",
  "phone": "Mobile: 7060882718"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652984"
  },
  "name": "aditi pokhriyal",
  "address": "40, Faguniakhet Gwal Bajoon, Bajoon, Nainital",
  "email": "anilrcherukupalli@gmail.com",
  "phone": "Mobile: 8595219857"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529ab"
  },
  "name": "akash rawat",
  "address": "agora, uttarkashi, uttarkashi",
  "email": "9458961246@gmail.com",
  "phone": "Mobile: 9458961246-9458961246"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529b8"
  },
  "name": "alpana bist (shiv home stay)",
  "address": "BIST NIWAS SPRING ROAD , MUSSOORIE, DEHRADUN",
  "email": "astikabist428@gmail.com",
  "phone": "Mobile: 6395863906-6395863906"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529ba"
  },
  "name": "alpana sah",
  "address": "orchard house, Jalna, Almora",
  "email": "orchardhouse.jalna@gmail.com",
  "phone": "Mobile: 9456779084"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529d4"
  },
  "name": "ambuj gupta (bungalow in the valley homestay)",
  "address": "15 Nemi Road Dalanwala, Dehradun, Dehradun",
  "email": "guptambuj@gmail.com",
  "phone": "Mobile: 9412914877"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529de"
  },
  "name": "amit chugh (amit home stay)",
  "address": "KHARA NO 44/2 NEW 215 K, Kuthal Ganw, Mussoorie Ro, DEHRADUN, DEHRADUN",
  "email": "directdirectpeshawar11@gmail.com",
  "phone": "Mobile: 9358123023"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529e3"
  },
  "name": "amitabh sharma",
  "address": "1, junoon in the hills darmani, nainital",
  "email": "bhowali@hotmail.com",
  "phone": "Mobile: 9412906895"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529e8"
  },
  "name": "amrita home stay",
  "address": "55, Vill Nabi ,Post Gunji,Dharchula , PITHORAGARH",
  "email": "amritahs@gmail.com",
  "phone": "Mobile: 9458925384"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529ee"
  },
  "name": "anand kumar (paradise inn homestay)",
  "address": "Majri Mafi, Haridwar Road, Mohakampur, Dehradun, Dehradun",
  "email": "mashuanand@gmail.com",
  "phone": "Mobile: 9897641455-9897641455"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529f5"
  },
  "name": "anand singh",
  "address": "15, NAINITAL, NAINITAL",
  "email": "anand.mer942@gmail.com",
  "phone": "Mobile: 9536121770"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529fd"
  },
  "name": "andhra glacier home stay gogina",
  "address": "43, GOGINA KAPKOT, bageshwar",
  "email": "ps8651405@gmail.com",
  "phone": "Mobile: 9410305818"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a13"
  },
  "name": "anirudh singh",
  "address": "Shivkuti - Kyunkaleshwer Mandir Marg , Pauri ( Gar, Pauri, Pauri",
  "email": "anirudhpauri@gmail.com",
  "phone": "Mobile: 9837087976-9837087976"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a2a"
  },
  "name": "anklesh",
  "address": "gram Monda, Post Chinva, Uttarkashi",
  "email": "9410111235@gmail.com",
  "phone": "Mobile: 9410111235"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652956"
  },
  "name": "100 years heritage homestay (sandeep rawat)",
  "address": "Main market.Jayharikhal., Jayharikhal, Pauri garhwal",
  "email": "Sandeep.rawatkotdwar@gmail.com",
  "phone": "Mobile: 9756103333-09756103333"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652957"
  },
  "name": "aadesh homestay",
  "address": "Village gangad, Mori, Uttarkashi",
  "email": "9410108107@gmail.com",
  "phone": "Mobile: 9410108107"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652958"
  },
  "name": "a.k.home stay",
  "address": "12, VILLAGE PASSI            , TEHRI GARHWAL",
  "email": "aknhomestay@gmail.com",
  "phone": "Mobile: 7579148053"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65296a"
  },
  "name": "aasiyana home stay",
  "address": "77, Vill Post Dharamghar  Chaukori Berinag, Pithoragarh",
  "email": "mahi.eagle7@gmail.com",
  "phone": "Mobile: 8006496546"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652980"
  },
  "name": "abhishek shah home stay",
  "address": "Village & P.O. Pipalkoti, Tehsil Chamoli, Pipalkoti, Chamoli",
  "email": "anhishekshah@gmail.com",
  "phone": "Mobile: 7535048589"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652983"
  },
  "name": "aditi negi",
  "address": "Harshil , Bhatwari , Uttarkashi",
  "email": "7579118339@gmail.com",
  "phone": "Mobile: 7579118339"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65298d"
  },
  "name": "aghora home stay surya pratap singh",
  "address": "0, GHUGTANI TAPOVAN, TEHRI GARHWAL",
  "email": "MANSOONSURYAM@GMAIL.COM",
  "phone": "Mobile: 9076964324"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652993"
  },
  "name": "ajay kumar",
  "address": "GULAB NAGAR TAPOVAN, TAPOVAN, TEHRI GARHWAL",
  "email": "raturishakti46@gmail.com",
  "phone": "Mobile: 9927637683"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652994"
  },
  "name": "ajay kumar kohli (zero point home stay)",
  "address": "Sanjha Darbar, Shrinagar Estate, Kempty fall Road, Mussoorie, Dehradun",
  "email": "ajaykohli338@gmail.com",
  "phone": "Mobile: 9997027111"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65299b"
  },
  "name": "ajay pande",
  "address": "SHRI NIWAS ,MAJHERA VILLAGE, GARAMPANI, NAINITAL",
  "email": "pande.ajay@outlook.com",
  "phone": "Mobile: 7837038220"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529a8"
  },
  "name": "ajruddin ansari",
  "address": "34 Choti Haldwani, Kaladhungi, Kaladhungi",
  "email": "azharansari011993@gmail.com",
  "phone": "Mobile: 8171190140-8171190140"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529ad"
  },
  "name": "akshat jain (status home stay)",
  "address": "18/4,OLD SURVEY ROAD, DEHRADUN, DEHRADUN",
  "email": "krishnaarmytraders@gmail.com",
  "phone": "Mobile: 8219235651Ph: 0135-2740550"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529b6"
  },
  "name": "alok singh thapli (parth home stay)",
  "address": "VILLAGE BHATTA, BARLOGANJ,  MUSSOORIE, DEHRADUN",
  "email": "parthhomestay@gmail.com",
  "phone": "Mobile: 8755097887"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529b7"
  },
  "name": "alok tanwar",
  "address": "Samarpan Cottage, Mehra Gaon, Farsauli, Bhowali, Nainital",
  "email": "alok.tanwar@gmail.com",
  "phone": "Mobile: 9818000602"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529bb"
  },
  "name": "alka singhal (divya palace home stay)",
  "address": "Glen Gown Estate, Spring Road, Library, Mussoorie, Dheradun",
  "email": "ashoksinghal141@gmail.com",
  "phone": "Mobile: 9410138808"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529d6"
  },
  "name": "amesh sharma (new clarence cottage homestay)",
  "address": "Clarence New Cottage Mall Road, Mussoorie , Dehradun",
  "email": "as.proaudio@gmail.com",
  "phone": "Mobile: 9702008999Ph: 0135-2983506"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529e1"
  },
  "name": "amit ramola (kuber home stay)",
  "address": "Mauja Marjri Mafi, Opp Rajeshwaripuram, Haridwar road Mohkampur, Dehradun, Dehradun",
  "email": "amit_ramola@yahoo.com",
  "phone": "Mobile: 9720050006"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529e9"
  },
  "name": "amit shah",
  "address": "UPPER MALL ROAD, NAINITAL, NAINITAL",
  "email": "virajhomestay@gmail.com",
  "phone": "Mobile: 9410337554"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529f2"
  },
  "name": "amod singh home stay",
  "address": "NAGLING, DHARCHULA, p",
  "email": "Amod@gmail.com",
  "phone": "Mobile: 757951885"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529f9"
  },
  "name": "anand singh rana",
  "address": "VILL- SIRASU, P.O.- MALA,, TAHSIL- JAKHANIKHAL, PAURI GARHWAL",
  "email": "anandsingh521@gmail.com",
  "phone": "Mobile: 8859707482"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a01"
  },
  "name": "ananda home stay",
  "address": "333, KAUSANI, BAGESHWAR",
  "email": "mathuraparsad0984@gmail.com",
  "phone": "Mobile: 9627352056"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a08"
  },
  "name": "anil badola",
  "address": "0, TAPOVAN , TEHRI GARHWAL",
  "email": "montorishikesh@gmail.com",
  "phone": "Mobile: 8954562463"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a0b"
  },
  "name": "anil bajaj",
  "address": "Stone Heights, Serentiy Estate, Chinkua ,Gethia, Nainital, Nainital",
  "email": "anilbajaj06@gmail.com",
  "phone": "Mobile: 8881112396"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a0c"
  },
  "name": "anil sah",
  "address": "PARNAKUTI, AYARPATA, NAINITAL, NAINITAL, NAINITAL",
  "email": "anilsah1950@gmail.com",
  "phone": "Mobile: 9410141740Ph: 05942-236435"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a0d"
  },
  "name": "anil singh",
  "address": "12, Uttarkashi, Uttarkashi",
  "email": "anilrana12021@gmail.com",
  "phone": "Mobile: 9411581267"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a14"
  },
  "name": "anil singh",
  "address": "218, JONK SWARGASHRAM, PAURI GARHWAL",
  "email": "VININEGI123@GMAIL.COM",
  "phone": "Mobile: 8077881578-07017885808"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a16"
  },
  "name": "anit sah",
  "address": "Camp Bagicha Cottage, Sari, PO Satbunga, Satbunga, Nainital",
  "email": "anit53@hotmail.com",
  "phone": "Mobile: 9811071135"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a1c"
  },
  "name": "anjali home stay, puran chandra arya",
  "address": "102 MAAT KASADEVI, ALMORA, ALMORA",
  "email": "anjalihomestaykasar@gmail.com",
  "phone": "Mobile: 8979531025"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652959"
  },
  "name": "aadi  kailash  home stay",
  "address": "VILL- KUTI , P.O- DHARCHULA GUNJI, Dharchula, pithoragarh",
  "email": "mahimansinghhomestay@gmail.com",
  "phone": "Mobile: 9410182510-7455997993"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652964"
  },
  "name": "aaradhna home stay",
  "address": "VILLAGE ANIMATH, P.O. PAINI,, TEHSIL JOSHIMATH, CHAMOLI",
  "email": "bhagwati12@gmail.com",
  "phone": "Mobile: 8755963455"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65296c"
  },
  "name": "abbal singh rana",
  "address": "VILL THANDI, UTTARKASHI, UTTARKASHI",
  "email": "abalsinghuki@gmail.com",
  "phone": "Mobile:"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652975"
  },
  "name": "abhay rawat (kashi niwas home stay)",
  "address": "Harawala, Haridwar Road, Near Delhi Farm , DEHRADUN, DEHRADUN",
  "email": "abhaydanu0217@gmail.com",
  "phone": "Mobile: 7300933967-7300933967"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65299c"
  },
  "name": "ajay rawat",
  "address": "VILL BEEF JANKICHATTI, UTTARKASHI, UTTARKASHI",
  "email": "ajayrawathomestay@gmail.com",
  "phone": "Mobile: 7409824671"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65299e"
  },
  "name": "ajeet rana (kings home stay)",
  "address": "Mothrowala Opposite Vrinda Garden, Kargi Road, DEHRADUN, DEHRADUN",
  "email": "fylfotpublicschool@gmail.com",
  "phone": "Mobile: 7351009100-7351009100"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65299f"
  },
  "name": "ajbar singh",
  "address": "13, Uttarkashi, Uttarkashi",
  "email": "ajbarsingh205@gmail.com",
  "phone": "Mobile: 8077805951"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529a0"
  },
  "name": "ajay thapa",
  "address": "ICE CORNER SSP OFFICE ALMORA, ALMORA, ALMORA",
  "email": "bhawanathapa1982@gmail.com",
  "phone": "Mobile: 9412092624"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529a4"
  },
  "name": "ajeet singh mehra",
  "address": "VILLAGE GAHNA POST OFFICE SARGAKHET, MUKTESHWER, NAINITAL",
  "email": "ajeetmehra.ntl2020@gmail.vom",
  "phone": "Mobile: 9927164326"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529ac"
  },
  "name": "akhil arora  (nirmal niwas homestay)",
  "address": "44-B, E.C. Road, Dehradun, Dehradun, Dehradun",
  "email": "akhilcibo@gmail.com",
  "phone": "Mobile: 9412057905Ph: 0135-2710686"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529af"
  },
  "name": "akshay bisht",
  "address": "Dak Bunglow , Hawalbagh , Almora",
  "email": "theomvilla@gmail.com",
  "phone": "Mobile: 8920976076"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529b2"
  },
  "name": "akshay chauhan",
  "address": "Monda, Chinva, Mori Uttarkashi, Uttarkashi",
  "email": "7579263429@gmail.com",
  "phone": "Mobile: 7579263429-7579281437"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529b4"
  },
  "name": "alam singh",
  "address": "20, lohaghat, champawat",
  "email": "chandansingh82497@gmail.com",
  "phone": "Mobile: 9456394055"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529bd"
  },
  "name": "amanda dorris mann (new carbery acres homestay)",
  "address": "Kunja Grant , Tehsil-Vikasnagar, Dehradun",
  "email": "dorismnn91@gmail.com",
  "phone": "Mobile: 8979787777"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529c3"
  },
  "name": "amar singh home stay",
  "address": "SELA, DHARCHULA, PITHORAGARH",
  "email": "Amarsingh@gmail.com",
  "phone": "Mobile: 9456784030"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529c4"
  },
  "name": "amar singh home singh",
  "address": "54, Vill go post Ghati Bagad  Dharchula, Pithoragarh",
  "email": "amar11@gmail.com",
  "phone": "Mobile: 7579431957"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529c6"
  },
  "name": "amar singh home stay",
  "address": "73, Vill -Boun ,Post Ccharcchum ,Dharchula , PITHORAGARH",
  "email": "amarhs00@gmail.com",
  "phone": "Mobile: 8958836543"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529cc"
  },
  "name": "amarsingh",
  "address": "VILL JAMU, POST PHATA, RUDRAPRAYAG",
  "email": "rudreshsingh111@gmail.com",
  "phone": "Mobile: 9891917610"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529d3"
  },
  "name": "ambrish semwal",
  "address": "SHRI GANGA LOK HOME STAY, MANDO BYPASS ROAD UTTARKASHI, UTTARKASHI",
  "email": "amrishsem@gmail.com",
  "phone": "Mobile: 9897567984"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529d7"
  },
  "name": "amit goel",
  "address": "Ranikhet road, Ghatti, Almora",
  "email": "thinkindia@hotmail.com",
  "phone": "Mobile: 9871698714"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529d8"
  },
  "name": "amit goel (sewa sadan homestay)",
  "address": "51 Mani Ram Road, Rishikesh, Dehradun",
  "email": "amitgoyal0154@gmail.com",
  "phone": "Mobile: 9897240153-09897240153"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529da"
  },
  "name": "amit",
  "address": "VILL AND PO BHANKOLI, UTTARKASHI, UTTARKASHI",
  "email": "amitbhankoli@gmail.com",
  "phone": "Mobile: 9568999501"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529ec"
  },
  "name": "anand ballabh upreti",
  "address": "Village Dharampur Dhankhola, Ramnagar, Nainital",
  "email": "anand.upreti15@gmail.com",
  "phone": "Mobile: 9818616145"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529ef"
  },
  "name": "amritash home stay, amit singh negi",
  "address": "181, TAPOVAN, TEHRI GARHWAL",
  "email": "amritashhomestay01@gmail.com",
  "phone": "Mobile: 8954910743"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529f4"
  },
  "name": "anand singh",
  "address": "VILL -VAJARI POST - RANA, UTTARKASI, UTTARKASHI",
  "email": "abf@gmail.com",
  "phone": "Mobile: 7895137431"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a00"
  },
  "name": "anant singh",
  "address": "13, Ganga Bhogpur Malla, Pauri Garhwal",
  "email": "anu4negi@gmail.com",
  "phone": "Mobile: 9144949244"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a03"
  },
  "name": "anil kapoor",
  "address": "88,ward no 2,sanguri gaon, bhimtal, bhimtal",
  "email": "harkrishan.medicals@gmail.com",
  "phone": "Mobile: 9711177103-9711177104"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a07"
  },
  "name": "anil kumar saxena",
  "address": "TEEN MOD, GHORAKHAL ROAD BHOWALI, NAINITAL",
  "email": "anilsaxena1985@gmail.com",
  "phone": "Mobile: 9810201984"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a15"
  },
  "name": "anish bawa (the royal home stay)",
  "address": "153/1 BAGRAL GAON NEAR DIT COLLEGE , Dehradun, Dehradun",
  "email": "bawasaraf12@gmail.com",
  "phone": "Mobile: 9896949190"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a18"
  },
  "name": "anita devi - buraansh home stay",
  "address": "VILL-SILETH, DUGADDA, PAURI",
  "email": "buraanshhomestay@gmail.com",
  "phone": "Mobile: 8979476193"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a19"
  },
  "name": "anita singh",
  "address": "SARGAKHET, MUKTESHWAR, NAINITAL",
  "email": "heaveninnmuktehwar@gmail.com",
  "phone": "Mobile: 7465077778-7465077778"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a26"
  },
  "name": "anjika naithani (naithani niwas homestay)",
  "address": "Lane no -2 Aadarsh nagar, Jollygrant, Teh-Doiwala, Dehradun",
  "email": "naithanihomestay@gmail.com",
  "phone": "Mobile: 8218701624"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652a28"
  },
  "name": "anju devi home stay",
  "address": "Rongkong, Gungi, DHARCHULA, PITHORAGARH",
  "email": "Anjudevihs@gmail.com",
  "phone": "Mobile: 9084938516"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652962"
  },
  "name": "aandev sharma",
  "address": "1, Champawat, Uttarakhand",
  "email": "Susilsarma125@gmail.com",
  "phone": "Mobile: 7248740244-7248740244"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652966"
  },
  "name": "aasha home stay",
  "address": "10, Vill ,Post -Go , Dharchula , Pithoragarh",
  "email": "aashadevi11hs@gmail.com",
  "phone": "Mobile: 7579183478"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652967"
  },
  "name": "aasara home stay",
  "address": "Village Soli, Kausani State, Bageshwar",
  "email": "himvadiresorts@gmail.com",
  "phone": "Mobile: 9412202800-09412202800"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65296f"
  },
  "name": "abhaya wasu (ivy cottage home stay)",
  "address": "Highland Mist Bhandar Gaon, Rajpur Road,,  Kuthal Gate, Dehradun",
  "email": "abhayawasu@gmail.com",
  "phone": "Mobile: 8283820566-9412954094"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652977"
  },
  "name": "abhimanyu rawat",
  "address": "raithal, bhatwari, uttarkashi, uttarkashi, uttarkashi",
  "email": "9927053494@gmail.com",
  "phone": "Mobile: 9927053494-9927053494"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652978"
  },
  "name": "abhimanyu singh",
  "address": "VILL AND POST - KUTHNAUR, UTTARKASHI, UTTARKASHI",
  "email": "9837261613@gmail.com",
  "phone": "Mobile: 9837261613"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65297a"
  },
  "name": "abhinav home stay sunil thpliyal",
  "address": "191, MATLI, UTTARKASHI",
  "email": "thapliyals659@gmail.com",
  "phone": "Mobile: 9897230918"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65297e"
  },
  "name": "adarsh home stay, prem ballabh pandey",
  "address": "Dhaspad, Almora, Almora",
  "email": "premballabh236@gmail.com",
  "phone": "Mobile: 9568419635-9897961039"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652988"
  },
  "name": "adventure avenue home stay and trekking services",
  "address": "VILLAGE-RAVIGRAM , P.O. JOSHIMATH, TEHSIL JOSHIMATH, CHAMOLI",
  "email": "chandrasingh@gmail.com",
  "phone": "Mobile: 8937064027"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65298b"
  },
  "name": "aditya puri",
  "address": "01 shiyat patti shayat, nainital, nainital",
  "email": "adityapuri35@yahoo.com",
  "phone": "Mobile: 9810290016"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db65298c"
  },
  "name": "adyasa home stay alam singh rawat",
  "address": "Villlage Naugaon Vyasghat, Pauri, Pauri Garhwal",
  "email": "vyaschattyadyashya@gmail.com",
  "phone": "Mobile: 9389167157"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652998"
  },
  "name": "ajay kumar tandon (r d inn home stay)",
  "address": "BY PASS CANAL ROAD, RASULPUR, VIKASNAGAR , VIKASNAGAR, DEHRADUN",
  "email": "ajaytandan888@gmail.com",
  "phone": "Mobile: 8077289433-9997175677"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db652999"
  },
  "name": "ajay pal singh panwar",
  "address": "01, Kirtinagar, Tehri Garhwal",
  "email": "mail.dkvs@gmail.com",
  "phone": "Mobile: 8126326666"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529a3"
  },
  "name": "ajeet singh",
  "address": "25, mautar kotgaon, uttarkashi",
  "email": "ajeetsinghrss@gmail.com",
  "phone": "Mobile: 9720119119"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529b0"
  },
  "name": "alakananda homestay digpal singh rana",
  "address": "SIRASU, PAURI GARHWAL, PAURI GARHWAL",
  "email": "ranadigpalsingh366@gmail.com",
  "phone": "Mobile: 9012275652"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529b5"
  },
  "name": "alankrita home stay",
  "address": "55, VillPost Wadda Pithoragarh, PITHORAGARH",
  "email": "kharkwalbasant11@gmail.com",
  "phone": "Mobile: 9897459903"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529bc"
  },
  "name": "amar gupta",
  "address": "0, TAPOVAN, TEHRI GARHWAL",
  "email": "shubhamhomestay2019@gmail.com",
  "phone": "Mobile: 9870816958"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529be"
  },
  "name": "amar kalp vriksh home stay",
  "address": "VILLAGE MANOHAR BAG PO & TEHSIL JOSHIMATH, TEHSIL JOSHIMATH, CHAMOLI",
  "email": "amar21@gmail.com",
  "phone": "Mobile: 8057808382"
},{
  "_id": {
    "$oid": "640f25e1e2c14ff1db6529bf"
  },
  "name": "alok ahuja (ganpati home stay)",
  "address": "WING NO 1/11/2 PREMNAGAR, DEHRADUN, DEHRADUN",
  "email": "alokahuja5@gmail.com",
  "phone": "Mobile: 9412967653"
},]